import { render, staticRenderFns } from "./pricePuListAdmin.vue?vue&type=template&id=c3c590b4&scoped=true"
import script from "./pricePuListAdmin.vue?vue&type=script&lang=js"
export * from "./pricePuListAdmin.vue?vue&type=script&lang=js"
import style0 from "./pricePuListAdmin.vue?vue&type=style&index=0&id=c3c590b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c590b4",
  null
  
)

export default component.exports